class Ranking {
    constructor() {
        this.is_selected = false
        this.ranking_position = ''
        this.id = null
        this.product = ''
        this.curve = ''
        this.auto_approved = false
        this.stock_in_dc = ''
        this.is_favorite = false
        this.is_guaranteed_stock = false
        this.is_new = false
        this.icons = ''
    }

    static get fieldNames() {
        return {
            is_selected: 'R.D.',
            ranking_position: 'Rank',
            id: 'ID',
            product: 'Produto',
            curve: 'Curva',
            stock_in_dc: 'Estoque CD',
            is_favorite: 'Favorito',
            is_guaranteed_stock: 'Garantido',
            is_new: 'Novo',
            icons: 'Situação'
        }
    }

    static get fieldTypes() {
        return {
            is_selected: 'boolean',
            ranking_position: 'number',
            id: 'number',
            product: 'text',
            curve: 'text',
            auto_approved: 'boolean',
            is_new: 'boolean',
            stock_in_dc: 'number',
            is_favorite: 'text',
            is_guaranteed_stock: 'text',
            icons: 'text'
        }
    }

    static get visibleFields() {
        return {
            is_selected: true,
            ranking_position: true,
            icons: true,
            id: true,
            product: true,
            curve: true,
            stock_in_dc: true,
            is_favorite: false,
            is_guaranteed_stock: false,
            is_new: false
        }
    }

    static get editableFields() {
        return {
            // id: false, // omit false
            // datetime_created: false,
            // datetime_updated: false
        }
    }
}

export default Ranking

export { Ranking }
